import { createFileRoute } from '@tanstack/react-router'
import TimesheetCalendarPage from '../../Pages/TimesheetCalendarPage/TimesheetCalendarPage'
import { CalendarSidebar } from '../../Components/Calendar/CalendarSidebar'
import PageBody from '../../Pages/Layout/PageBody'
import PageSidebar from '../../Pages/Layout/PageSidebar'
import LoadingSpinner from '../../Components/LoadingSpinner'
import ErrorComponent from '../../Components/ErrorComponent'
import { qf } from '../../Queries/queryFormatter'
import { endOfWeek, parse, startOfWeek, format } from 'date-fns'
import { processTRPCData } from '../../Queries/fetchData'
import {
    canViewRoute,
    migratedToV2,
} from '../../State/Permissions/HasPermissions'
import SessionStore from '../../State/SessionStore'
import PermissionDenied from '../../Pages/PermissionDenied'
import { setLayoutDefaults } from '@2/layout/layout-store'
import { Sidebar } from '@2/layout/sidebar'
import { CenterPadPageBody } from '@2/layout/page-body'
import { useSidebarStack } from '@2/layout/sidebar'
import { useEffect } from 'react'
import { trpc } from '@/system/trpc'

export const Route = createFileRoute('/_private/timesheets/calendar')({
    beforeLoad: ({ params }) => {
        if (!canViewRoute(SessionStore.user, 'timesheetCalendar', params))
            throw new Error('Permission Denied')
        setLayoutDefaults({
            pageTitle: 'Timesheet Calendar',
            subMenu: 'time',
        })
    },
    errorComponent: ({ error, reset }) => {
        if (error.message === 'Permission Denied') return <PermissionDenied />
        return <ErrorComponent error={error} reset={reset} />
    },
    pendingComponent: LoadingSpinner,
    loader: async ({ location }) => await loader(location.search),
    loaderDeps: ({ search: { date, staffId } }) => ({
        date,
        staffId,
    }),
    component: Wrapper,
})
const loader = async ({ date, staffId } = {}) => {
    // Use nullish coalescing to set default date as today's date formatted
    date = date ?? format(new Date(), 'yyyy-MM-dd')
    const startDate = format(
        startOfWeek(new Date(date), { weekStartsOn: 1 }),
        'yyyy-MM-dd'
    )
    const endDate = format(
        endOfWeek(new Date(date), { weekStartsOn: 1 }),
        'yyyy-MM-dd'
    )
    const data = await trpc.legacy.getTimesheetData.query({
        startDate,
        endDate,
        staffId,
    })
    return processTRPCData(data)
}
function Wrapper() {
    let { date, staffId } = Route.useSearch()
    // Parse the date string or use current date if no date provided
    date = date ? parse(date, 'yyyy-MM-dd', new Date()) : new Date()
    const { addToSidebar } = useSidebarStack()
    useEffect(() => {
        addToSidebar(<CalendarSidebar />, { hideClose: true })
    }, [])
    if (migratedToV2()) {
        return (
            <>
                <CenterPadPageBody>
                    <TimesheetCalendarPage date={date} staffId={staffId} />
                </CenterPadPageBody>
            </>
        )
    }
    return (
        <>
            <PageBody>
                <TimesheetCalendarPage date={date} staffId={staffId} />
            </PageBody>

            <PageSidebar>
                <CalendarSidebar />
            </PageSidebar>
        </>
    )
}
